type ProfileMenuItemType = {
  label: string;
  subTitle?: string;
  icon: JSX.Element;
  value?: string | JSX.Element;
  onClick?: () => void;
};

export function ProfileMenuItem({
  icon,
  label,
  subTitle,
  value,
  onClick
}: ProfileMenuItemType) {
  return (
    <div
      className="hover:bg-outline-thin w-full cursor-pointer px-6 transition-colors duration-200"
      onClick={onClick}
      role="menuitem"
    >
      <div className="border-outline-thin flex min-h-[56px] items-center gap-4 border-t py-2">
        <div className="text-on-surface-medium-emphasis text-headline-5">
          {icon}
        </div>
        <span className="text-subtitle-1 text-on-surface-high-emphasis flex flex-col">
          {label}
          {subTitle && (
            <span className="text-extra-caption text-on-surface-medium-emphasis py-1">
              {subTitle}
            </span>
          )}
        </span>
        {value && (
          <span className="text-caption text-on-surface-high-emphasis mr-auto">
            {value}
          </span>
        )}
      </div>
    </div>
  );
}
